import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';

class CustomFieldsRow extends React.Component {
  state = {
    editMode: false,
    deleteMode: false,
    name: this.props.customFieldKey.name,
    prioritized: !!this.props.customFieldKey.prioritized
  }

  updateKey = () => {
    const { customFieldKey, updateVisibleKeys } = this.props;
    const { name, prioritized } = this.state;
    const data = { data: { attributes: { name, prioritized: !!prioritized } } };
    $.ajax({
      type: 'PUT',
      url: `/api/v4/custom_field_keys/${customFieldKey.key}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(data),
      context: this,
      success: () => {
        updateVisibleKeys(customFieldKey.key, name);
      },
      error: (xhr) => {
        const bodyText = xhr.responseJSON.errors || "Please try again.";
        if (bodyText.toLowerCase().includes("prioritiz")) {
          this.setState((prevState) => ({ prioritized: !prevState.prioritized }));
        }
        Notify.create({ type: "error", title: "Failed to updated", body: bodyText });
      }
    });
  }

  deleteKey = () => {
    const { customFieldKey, updateVisibleKeys } = this.props;
    $.ajax({
      type: 'DELETE',
      url: `/api/v4/custom_field_keys/${customFieldKey.key}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      context: this,
      success: () => {
        updateVisibleKeys(customFieldKey.key, null);
      },
      error: () => {
        Notify.create({ type: "error", title: "Failed to delete. Please try again." });
      }
    });
  }

  togglePrioritization = () => {
    this.setState((prevState) => (
      { prioritized: !prevState.prioritized }),
    () => this.updateKey());
  }

  toggleEditMode = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
      deleteMode: !prevState.editMode ? false : prevState.deleteMode
    }));
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  renameKey = () => {
    if (this.state.name && this.state.name !== this.props.customFieldKey.name) {
      this.updateKey();
      this.setState({ editMode: false });
    } else {
      Notify.create({
        title: t('Please enter a name.'),
        type: 'error',
      });
    }
  }

  renderCustomFieldValues = () => {
    const { key } = this.props.customFieldKey;
    $.ajax({
      url: `/${BF.fx.brandfolder().slug}/bulk_management/custom_field_key/${key}/values`,
      type: 'GET',
      beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success(response) {
        document.getElementsByClassName("j-serverside-page")[0].innerHTML = response;
        /* eslint-disable no-undef */
        ReactRailsUJS.unmountComponents('#manage-custom-fields');
        ReactRailsUJS.mountComponents('#manage-custom-field-values');
        /* eslint-enable no-undef */
      },
      error() {}
    });
  }

  showKey() {
    const { counted_assets, uniq_values } = this.props.customFieldKey;
    return (
      <React.Fragment>
        <div className="show-custom-fields-mode">
          <div className="custom-fields-information">
            { this.renderKey() }
            <div className="fifteen-width">
              <a onClick={this.renderCustomFieldValues}>
                {t((uniq_values > 0)
                  ? `${uniq_values} Value${uniq_values > 1 ? "s" : ""}`
                  : "-")}
              </a>
            </div>
            <div className="fifteen-width">
              <p>{t((counted_assets > 0)
                ? `${counted_assets}`
                : "-")}
              </p>
            </div>
            <div className="fifteen-width">
              <Checkbox
                checked={this.state.prioritized}
                size="md"
                toggle={this.togglePrioritization}
              />
            </div>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm edit-custom-fields"
              onClick={this.toggleEditMode}
              type="button"
            >
              Rename
            </button>
            <button
              className="delete-custom-fields"
              onClick={this.toggleDeleteMode}
              onKeyUp={this.toggleDeleteMode}
              type="button"
            >
              <span className="bff-trash" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderKey() {
    const { name } = this.state;
    return (
      <div className="quarter-width">
        <a href={`/${BF.fx.brandfolder().slug}?q=custom_fields.${escape(name)}.moderate:(*)`}>
          <span className="custom-fields-name">
            {name}
          </span>
        </a>
      </div>
    );
  }

  renderEdit() {
    const { name, counted_assets } = this.props.customFieldKey;
    return (
      <div className="edit-custom-fields-mode">
        <input
          id={`${name}-input`}
          type="text"
          onChange={(e) => this.setState({ name: e.target.value })}
          value={this.state.name}
        />
        <div className="edit-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleEditMode}
          >
          Cancel
          </button>
          <button
            className="button primary md"
            type="button"
            onClick={this.renameKey}
          >
            {t(`Rename ${counted_assets > 0 ? counted_assets : ""}
              Key${(counted_assets > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderDelete() {
    const { counted_assets } = this.props.customFieldKey;
    return (
      <div className="delete-custom-fields-mode">
        {this.renderKey()}
        <div className="delete-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleDeleteMode}
          >
            {t("Cancel")}
          </button>
          <button
            className="button warning md"
            type="button"
            onClick={this.deleteKey}
          >
            {t(`Delete ${counted_assets} Key${(counted_assets > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderRow() {
    const { editMode, deleteMode } = this.state;
    if (editMode) { return this.renderEdit(); }
    if (deleteMode) { return this.renderDelete(); }
    return this.showKey();
  }

  render() {
    return this.renderRow();
  }
}

CustomFieldsRow.propTypes = {
  customFieldKey: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    prioritized: PropTypes.bool,
    counted_assets: PropTypes.number,
    uniq_values: PropTypes.number
  }).isRequired,
  updateVisibleKeys: PropTypes.func.isRequired,
};

export default CustomFieldsRow;
